import {onboardingStatuses, onboardingSteps, onboardingSubStatuses} from "constants/constants";
import {getConstant, isConstantExist} from "utils/helpers";
import {useTranslation} from "react-i18next";

export const useCourierOnboarding = () => {
    const {t} = useTranslation();
    const renderOnboardingStatus = ({onboardingStatus, isApplicationRejected}) => {
        return isApplicationRejected && onboardingStatus !== "blocked"
            ? "Başvuru Olumsuz"
            : isConstantExist(onboardingStatuses, onboardingStatus)
            ? t(getConstant(onboardingStatuses, onboardingStatus).translation_key, {
                  ns: "onboardingStatuses"
              })
            : "-";
    };

    const renderOnboardingStep = ({onboardingStep}) => {
        return isConstantExist(onboardingSteps, onboardingStep)
            ? t(getConstant(onboardingSteps, onboardingStep).translation_key, {
                  ns: "onboardingSteps"
              })
            : "-";
    };

    const renderOnboardingSubStatus = ({
        onboardingSubStatus,
        isApplicationRejected,
        onboardingStatus
    }) => {
        return isApplicationRejected && onboardingStatus !== "blocked"
            ? "-"
            : isConstantExist(onboardingSubStatuses, onboardingSubStatus)
            ? t(getConstant(onboardingSubStatuses, onboardingSubStatus).translation_key, {
                  ns: "onboardingSubStatuses"
              })
            : "-";
    };

    return {
        renderOnboardingStatus,
        renderOnboardingStep,
        renderOnboardingSubStatus
    };
};
